export const CourseType = {
    101: "文功战况",
    100: "武功战况"
}

//评价为星星元素
export const StarList=[802,817]